import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    dataCrud: [],
    modelForm: {},
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    dataCrud: (state) => state.dataCrud,
    modelForm: (state) => state.modelForm,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.interviewSchema(),
          apiClient.catIntervAccessibility(),
          apiClient.catIntervAttitude(),
          apiClient.catIntervEyeContact(),
        ]);
        const [schemaRes, catIntervAccessibility, catIntervAttitude, catIntervEyeContact] =
          responses.map((res) => res?.data ?? {});

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.interv_accessibility.items = catIntervAccessibility.data ?? [];
        schema.formCrud.interv_attitudes.items = catIntervAttitude.data ?? [];
        schema.formCrud.interv_eye_contact.items = catIntervEyeContact.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxInterview(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxInterview(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateCAxInterview(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteCAxInterview(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
